import React from 'react';

import { Text, Box, Center, Button, Heading, Image } from '@chakra-ui/react';

import txtWording from './locales';
import { BUTTON_PADDING_PROPS, DEFAULT_BUTTON_PROPS } from '@/constants/colors';

import { ASSETS_BUTTERFLY } from '@/constants/assets';
import { TEXT_PROPS } from '@/constants/default-props';

function ModalAddress({ onCopyText, lang }) {
  const name = 'Groom & Bride';
  const address = `Jalan Medan Merdeka Utara Gambir Jakarta 10160, Indonesia`;

  return (
    <Box m="60px 0 24px 0">
      <Box width="100%" margin="24px auto 0 auto" textAlign="center" position="relative">
        <Heading {...TEXT_PROPS.heading}>
          {txtWording.sendGift[lang]}
          <Image
            src={ASSETS_BUTTERFLY}
            className="butterfly-gift-right"
            transform="rotateY(180deg)"
          />
        </Heading>
      </Box>

      <Box padding="8px 0 36px 0" {...TEXT_PROPS.body} textAlign="center">
        <Text color="mainColorText" fontSize="20px" marginTop="0" fontWeight="bold">
          {name} <br />
        </Text>
        <Text>{address}</Text>
        <Center>
          <Button
            {...DEFAULT_BUTTON_PROPS}
            {...BUTTON_PADDING_PROPS}
            mt="16px"
            fontSize="16px"
            padding="1em 1.5em"
            onClick={() => onCopyText(`${name} - ${address}`, txtWording.successCopyAddress[lang])}
          >
            {txtWording.modalCopyAddress[lang]}
          </Button>
        </Center>
      </Box>
    </Box>
  );
}

export default ModalAddress;
